import { useQuery } from '@tanstack/react-query';
import { useSettingApi } from '../api/useSettingApi';
import { type Setting } from '@/models/Setting';

export const useGetSettingsByCodes = (code: string) => {
  const { fetchSettingsByCodes } = useSettingApi();
  return useQuery<Setting[], Error>({
    queryKey: ['setting', { code }],
    queryFn: () => fetchSettingsByCodes(code),
  });
};
